var map = {
	"./kg/agenda.json": [
		8049,
		8049
	],
	"./kg/appeal.json": [
		2331,
		2331
	],
	"./kg/bills.json": [
		9310,
		9310
	],
	"./kg/bvi.json": [
		2321,
		2321
	],
	"./kg/comments.json": [
		9329,
		9329
	],
	"./kg/committee.json": [
		1559,
		1559
	],
	"./kg/deputy.json": [
		4917,
		4917
	],
	"./kg/faction.json": [
		30,
		30
	],
	"./kg/global.json": [
		1362,
		1362
	],
	"./kg/home.json": [
		9110,
		9110
	],
	"./kg/initiative.json": [
		6396,
		6396
	],
	"./kg/kenesh.json": [
		3164,
		3164
	],
	"./kg/law-activity.json": [
		6444,
		6444
	],
	"./kg/manager.json": [
		5897,
		5897
	],
	"./kg/page.json": [
		6903,
		6903
	],
	"./kg/petition.json": [
		4357,
		4357
	],
	"./kg/post.json": [
		9397,
		9397
	],
	"./kg/press.json": [
		3469,
		3469
	],
	"./kg/radio.json": [
		8604,
		8604
	],
	"./kg/search.json": [
		7456,
		7456
	],
	"./kg/toraga.json": [
		1730,
		1730
	],
	"./kg/user.json": [
		828,
		828
	],
	"./ru/agenda.json": [
		2018,
		2018
	],
	"./ru/appeal.json": [
		5446,
		5446
	],
	"./ru/bills.json": [
		5255,
		5255
	],
	"./ru/bvi.json": [
		5429,
		5429
	],
	"./ru/comments.json": [
		9466,
		9466
	],
	"./ru/committee.json": [
		9196,
		9196
	],
	"./ru/deputy.json": [
		3613,
		3613
	],
	"./ru/faction.json": [
		2590,
		2590
	],
	"./ru/global.json": [
		5140,
		5140
	],
	"./ru/home.json": [
		9712,
		9712
	],
	"./ru/initiative.json": [
		9587,
		9587
	],
	"./ru/kenesh.json": [
		6076,
		6076
	],
	"./ru/law-activity.json": [
		4422,
		4422
	],
	"./ru/manager.json": [
		8787,
		8787
	],
	"./ru/page.json": [
		8014,
		8014
	],
	"./ru/petition.json": [
		1148,
		1148
	],
	"./ru/post.json": [
		6395,
		6395
	],
	"./ru/press.json": [
		9254,
		9254
	],
	"./ru/radio.json": [
		6975,
		493
	],
	"./ru/search.json": [
		6892,
		6892
	],
	"./ru/toraga.json": [
		356,
		356
	],
	"./ru/user.json": [
		3908,
		3908
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 574;
module.exports = webpackAsyncContext;